import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import Label from '../../components/shared/Label';
import { HeaderWrapper } from './styles';

const MotorSportHeader = ({ isMobile }) => (
  <HeaderWrapper>
    <Row style={{
      width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
    }}
    >
      <Col lg={1.5} md={2.5} sm={2} style={{ padding: '0' }}>
        <Label
          label="Data"
          weight="bold"
        />
      </Col>
      {!isMobile &&
        <Col md={2} sm={1} style={{ padding: '0' }}>
          <Label
            label="Circuito"
            weight="bold"
          />
        </Col>
      }
      <Col lg={2} md={3} sm={3} style={{ padding: '0' }}>
        <Label
          label="Gran Premio"
          weight="bold"
        />
      </Col>
      {!isMobile &&
        <Col md={1} sm={1} style={{ padding: '0' }}>
          <Label
            label="Giri"
            weight="bold"
          />
        </Col>
      }
      {!isMobile &&
        <Col md={2} sm={2} style={{ padding: '0' }}>
          <Label
            label="Distanza"
            weight="bold"
          />
        </Col>
      }
      <Col lg={3} md={6} sm={6} style={{ padding: '0' }}>
        <Label
          label={window.matchcenterPage.competitionId !== 2 ? 'Vincitore' : 'Vincitore gara 1-2'}
          weight="bold"
        />
      </Col>
    </Row>
  </HeaderWrapper>
);

MotorSportHeader.propTypes = {
  isMobile: PropTypes.bool,
};

export default MotorSportHeader;



// WEBPACK FOOTER //
// ./src/components/MotorSportHeader/index.js